import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type Theme = "light" | "dark" | "system";

interface ThemeState {
  currentTheme: Theme;
  isDarkMode: boolean;
}

const getInitialTheme = (): Theme => {
  let storedTheme = localStorage.getItem("theme");
  if (!storedTheme) {
    storedTheme = "system";
    localStorage.setItem("theme", storedTheme);
  }
  return storedTheme as Theme;
};

const initialState: ThemeState = {
  currentTheme: getInitialTheme(),
  isDarkMode: false,
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<Theme>) => {
      state.currentTheme = action.payload;
      localStorage.setItem("theme", action.payload);
    },
    setIsDarkMode: (state, action: PayloadAction<boolean>) => {
      state.isDarkMode = action.payload;
    },
  },
});

export const { setTheme, setIsDarkMode } = themeSlice.actions;

export const selectTheme = (state: { theme: ThemeState }) =>
  state.theme.currentTheme;

export const selectIsDarkMode = (state: { theme: ThemeState }) =>
  state.theme.isDarkMode;

export default themeSlice.reducer;
